/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */

/**
 * What a logbook entry records. Travels as an int on the wire — never renumber.
 */
export type FacilityFlowCoreModulesFleetEntitiesVehicleLogbookEntryKind = typeof FacilityFlowCoreModulesFleetEntitiesVehicleLogbookEntryKind[keyof typeof FacilityFlowCoreModulesFleetEntitiesVehicleLogbookEntryKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FacilityFlowCoreModulesFleetEntitiesVehicleLogbookEntryKind = {
  NUMBER_1: 1,
  NUMBER_2: 2,
} as const;
